module.exports = __webpack_public_path__ + "img/item_placeholder.0ae816f3.png";